import axios from 'axios'
import { API_ROOT } from '../services/api'
import { ADMIN_GET_ALL_USER, ADMIN_GET_ROOMS } from './actionTypes'
import { get } from 'lodash'

export const getRoomAll = () => (dispatch) => {
  dispatch({ type: ADMIN_GET_ROOMS.REQUEST, isLoading: true });
  return axios({
    method: "get",
    url: `${API_ROOT}/user/rooms`,
   
  })
    .then((res) => {
      dispatch({ type: ADMIN_GET_ROOMS.SUCCESS, payload: res.data });
      return res;
    })
    .catch((error) => {
      dispatch({ type: ADMIN_GET_ROOMS.FAILURE, payload: error.message });
    });
};

export const login = (username, password) => {
  return axios({
    method: 'post',
    url: `${API_ROOT}/user/login`,
    headers: { 'Content-Type': 'application/json' },
    data: JSON.stringify({ username, password }),
  })
    .then(res => {
      console.log(res.status)
      if (res.status == 200) {
        localStorage.setItem('access-token', res.data)
        return res
      }
      
      throw Error(res.status)
    })
    .catch(error => {
      
      return error.response;
    })
}

export const changePassword = data => {
  return axios({
    method: 'post',
    url: `${API_ROOT}/user/changepassword`,
    data: data,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('access-token')
    },
  })
    .then(res => {
      if (res.status == 200) {
        return res
      }
      throw Error(res.status)
    })
    .then(res => {
      localStorage.setItem('access-token', res.data)
      return res
    })
    .catch(error => {
    })
}

export const renewAccessToken = () => {
  return async () => {
    const handleSuccess = async (accessToken) => {
      localStorage.setItem('access-token', accessToken)
    }
    axios({
      method: 'get',
      url: `${API_ROOT}/user/verifyToken`,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('access-token')
      },
    })
      .then(async (res) => {
        const accessToken = get(res, 'data', '')
        if (accessToken) {
          await handleSuccess(accessToken)
        } else {
          throw 'error'
        }
      })
      .catch((error) => {
        localStorage.removeItem('access-token')
      })
  }
}

export const forgotPassword = (forgotModel) => {
  return axios({
    method: 'post',
    url: `${API_ROOT}/user/forgotpassword`,
    data: forgotModel
  }).then((res) => {
    return res;
  }).catch((error) => {
    return error;
  })
}

